export const kOutlookConstants = {
	scopes: ["https://graph.microsoft.com/User.Read", "email", "https://graph.microsoft.com/Mail.ReadWrite", "https://graph.microsoft.com/MailboxSettings.ReadWrite", "offline_access", "openid"],
	clientId: process.env.REACT_APP_OUTLOOK_CLIENT_ID,
	redirectUri: process.env.REACT_APP_OUTLOOK_REDIRECT_URI,
	baseUrl: process.env.REACT_APP_BASE_URL,
	authorizationEndpoint: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
	tokenEndpoint: "https://login.microsoftonline.com/common/oauth2/v2.0/token",
	revocationEndpoint: "https://login.microsoftonline.com/common/oauth2/v2.0/token",
};
